import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    detectionTitle;
    idealList;
    titleList;
    disabled;
    value = 2;
    isText = false;
    formData = {};
    created() {
        this.$set(this.formData, 'idealList', this.idealList);
    }
    get rules() {
        return {
            value: [
                { required: true, message: this.inputPlaceholder, trigger: 'blur' },
                { pattern: this.getPattern(), message: this.inputPlaceholder, trigger: 'blur' },
            ],
        };
    }
    getPattern() {
        return /^([1-9]|[1-9]\d|100)$/;
    }
    inputPlaceholder() {
        return this.$t('thresholdInputRule');
    }
    changeValue(val) {
        if (val.value > 100) {
            val.value = 100;
            return;
        }
        else if (val.value < 1) {
            val.value = '';
            return;
        }
        this.$emit('update:value', val);
    }
};
__decorate([
    Prop()
], default_1.prototype, "detectionTitle", void 0);
__decorate([
    Prop()
], default_1.prototype, "idealList", void 0);
__decorate([
    Prop()
], default_1.prototype, "titleList", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
default_1 = __decorate([
    Component({
        name: 'ValidTime',
        components: {},
        i18n: {
            messages: {
                zh: {
                    thresholdInputRule: '请输入匹配度阈值，1-100',
                    ideal: '推荐值',
                },
                en: {
                    thresholdInputRule: 'Please enter matching rate, 1-100',
                    ideal: 'Ideal',
                },
            },
        },
    })
], default_1);
export default default_1;
